export default "__VITE_ASSET__43d92635__"